import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { id: Number, target: String, color: String };

  connect() {
    if (this.hasIdValue) {
      this.loadScript();
    }
  }

  loadScript() {
    const targetName = this.hasTargetValue ? this.targetValue : 'unique_name';
    const script = document.createElement('script');
    const widgetUrl = new URL('https://campaigns.do/campaigns/widget/v1/sdk.js');
    widgetUrl.searchParams.append('campaign_id', this.idValue);
    widgetUrl.searchParams.append('component_height', '80%');
    widgetUrl.searchParams.append('component_width', '100%');
    widgetUrl.searchParams.append('component_template', 'sm');
    widgetUrl.searchParams.append('target_query', `#${targetName}`);
    if (this.colorValue !== '') {
      widgetUrl.searchParams.append('component_brand_color', `${this.colorValue}`);
    }
    script.src = widgetUrl.href;
    script.defer = true;
    document.body.appendChild(script);
  }
}
